// extracted by mini-css-extract-plugin
export default {"senderImageContent":"form_senderImageContent__q4PmF","imageDisplay":"form_imageDisplay__EZPC-","label":"form_label__OQcNU","blue":"form_blue__LHq7C","red":"form_red__6W8RB"};